import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { getAreas } from 'api/areas';
import { createFolderArea } from 'api/folders';
import Popup from 'components/Popup';
import Button from 'components/Button';
import SelectInput from 'components/Form/SelectInput';

export default function FolderAddAreasPopup({
    visible,
    setVisible,
    present = []
}) {

    const { folderId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['createFolderArea'],
        mutationFn: createFolderArea,
        onSuccess: () => {
            cache.invalidateQueries(['folders', folderId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error creating folder-area:", error);
        }
    });

    const { data: areas } = useQuery({
        queryKey: ['areas'],
        queryFn: async () => await getAreas({}),
    });


    const selectOptions = areas?.map(area => {
        return {
            value: area._id,
            label: area.name
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: folderId,
            data: {
                area: e.target.area.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona area"
                        name="area"
                        options={selectOptions.filter(element => !present?.includes(element.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
